export default "/_next/static/fonts/tt_norms_pro_extrabold-059efaedf03088a0ff92c04326cbb4ba.woff";